import { registerCorvidEvent } from '@wix/editor-elements-corvid-utils';
import type {
  CorvidTypes,
  ICorvidEvent,
  ICorvidEventHandler,
  IComponentEvent,
} from '@wix/editor-elements-types/corvid';
import type { GalleryItemProps, WixSDKItem } from '../../ProGallery.types';

export interface IOnGalleryNavigationStartPropsSDKProps {
  items: Array<GalleryItemProps>;
  wixSDKItems?: Array<WixSDKItem>;
}

export type OnGalleryNavigationStartPayload = {
  itemIndex: number;
};

export type OnGalleryNavigationStartComponentPayload = IComponentEvent<
  'onGalleryNavigationStart',
  OnGalleryNavigationStartPayload
>;

export type OnGalleryNavigationStartCorvidEvent = ICorvidEvent<
  'onGalleryNavigationStart',
  OnGalleryNavigationStartPayload
>;

export type IOnGalleryNavigationStartSDKAction = {
  onGalleryNavigationStart: (
    event: OnGalleryNavigationStartComponentPayload,
  ) => void;
};

export interface IOnGalleryNavigationStartSDKProps {
  onGalleryNavigationStart(
    handler: ICorvidEventHandler<OnGalleryNavigationStartCorvidEvent>,
  ): void;
}

export const onGalleryNavigationStartSDKFactory: CorvidTypes.CorvidSDKFactory<
  IOnGalleryNavigationStartPropsSDKProps,
  IOnGalleryNavigationStartSDKProps
> = api => {
  return {
    onGalleryNavigationStart(handler) {
      registerCorvidEvent<
        OnGalleryNavigationStartComponentPayload,
        OnGalleryNavigationStartCorvidEvent
      >('onGalleryNavigationStart', api, handler, ({ componentEvent }) => {
        return componentEvent;
      });
    },
  };
};
